var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "brain"
  }, [_c('div', {
    staticClass: "debugInfo visible"
  }, [_c('div', {
    staticClass: "buildinfo",
    attrs: {
      "id": "buildinfo"
    }
  }), _c('button', {
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleDebugPanel($event);
      }
    }
  }, [_vm._v("Debug Panel")])]), _c('div', {
    staticClass: "debugPanel"
  }, [_c('div', {
    staticClass: "debugGroup"
  }, [_c('div', {
    staticClass: "progressDivider"
  }, [_c('div', {
    staticClass: "debugData"
  }, [_c('h2', [_vm._v("Settings")]), _c('ul', [_c('li', [_c('span', [_vm._v("isTouchDevice:")]), _vm._v("\n              " + _vm._s(_vm.isTouchDevice) + "\n            ")]), _c('li', [_c('span', [_vm._v("Home Use Token:")]), _vm._v("\n              " + _vm._s(_vm.homeUseToken) + "\n            ")]), _c('li', [_c('span', [_vm._v("Token (Clever User):")]), _vm._v("\n              " + _vm._s(_vm.token) + "\n            ")]), _c('li', [_c('span', [_vm._v("Grade:")]), _vm._v("\n              " + _vm._s(_vm.grade) + "\n            ")]), _c('li', [_c('span', [_vm._v("Student ID:")]), _vm._v("\n              " + _vm._s(_vm.studentId) + "\n            ")]), _c('li', [_c('span', [_vm._v("Classroom ID:")]), _vm._v("\n              " + _vm._s(_vm.classroomId) + "\n            ")]), _c('li', [_c('span', [_vm._v("User First Name:")]), _vm._v("\n              " + _vm._s(_vm.firstName) + "\n            ")]), _c('li', [_c('span', [_vm._v("Product Key:")]), _vm._v("\n              " + _vm._s(_vm.productId) + "\n            ")]), _c('li', [_c('span', [_vm._v("ToolbarMode:")]), _vm._v("\n              " + _vm._s(_vm.toolbarMode) + "\n            ")]), _c('li', [_c('span', [_vm._v("Curriculum Complete:")]), _vm._v("\n              " + _vm._s(_vm.curriculumComplete) + "\n            ")]), _c('li', [_c('span', [_vm._v("Current Theme:")]), _vm._v("\n              " + _vm._s(_vm.currentTheme) + "\n            ")]), _c('li', [_c('span', [_vm._v("Current Week:")]), _vm._v("\n              " + _vm._s(_vm.currentWeek) + "\n            ")]), _c('li', [_c('span', [_vm._v("Current ASN:")]), _vm._v("\n              " + _vm._s(_vm.currentASN) + "\n            ")]), _c('li', [_c('span', [_vm._v("Current activityId:")]), _vm._v("\n              " + _vm._s(_vm.activityId) + "\n            ")]), _c('li', [_c('span', [_vm._v("Current Activity:")]), _vm._v("\n              " + _vm._s(_vm.currentActivity) + "\n            ")]), _c('li', [_c('span', [_vm._v("Active Assessment:")]), _vm._v("\n              " + _vm._s(_vm.isActiveAssessment) + "\n            ")])])]), _c('qahelper')], 1)]), _c('div', {
    staticClass: "debugGroup"
  }, [_c('h2', [_vm._v("Classrooms")]), _c('div', {
    staticClass: "classRoomStore"
  }, _vm._l(_vm.classroomsDisplay, function (item, index) {
    return _c('div', {
      key: ("classroom-" + index),
      staticClass: "classroomItem"
    }, [_c('p', [_vm._v("\n            classroomId:\n            "), _c('span', [_vm._v(_vm._s(item.id))])]), _c('p', [_vm._v("\n            teacher:\n            "), _c('span', [_vm._v(_vm._s(item.teacher.username))])]), _c('p', [_vm._v("\n            name:\n            "), _c('span', [_vm._v(_vm._s(item.name))])]), _c('p', [_vm._v("\n            grades:\n            "), _c('span', [_vm._v(_vm._s(item.gradeLevels))])])]);
  }), 0), _c('button', {
    staticClass: "clearStore",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.clearStore($event);
      }
    }
  }, [_vm._v("Clear Store")])]), _c('div', {
    staticClass: "debugGroup"
  }, [_c('h2', [_vm._v("Activity Tester")]), _c('div'), _c('button', {
    staticClass: "clearStore",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.changeMode('tester');
      }
    }
  }, [_vm._v("Go To Tester")])]), _c('div', {
    staticClass: "debugGroup center"
  }, [_c('button', {
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleDebugPanel($event);
      }
    }
  }, [_vm._v("Close Panel")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }